import React, { useEffect } from 'react';
import { History, Location } from 'history';
import { validateEmail } from 'utils/validates';
import { decodeEmail } from 'utils/normalizeData';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import InputGeneral from 'components/common/FormControls/FormInputs';
import ButtonMedium from 'components/common/Buttons/ButtonMedium';
import './styles.scss';
import { AuthClientInstance } from 'api/authClientInstance';

export interface ILocationState {
  email: string;
}

interface IState {
  email: Nullable<string>;
  isSuccess: boolean;
}

export interface IOwnProps {
  history: History;
  location: Location<ILocationState>;
}

const ForgotPassword = (props: IOwnProps) => {
  const { location, history } = props;

  const defaultState = {
    email: null,
    isSuccess: false,
  };
  const [state, setState] = React.useState<IState>(defaultState);
  const { email, isSuccess } = state;

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setState((prevState) => ({
      ...prevState,
      email: value,
    }));
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      await AuthClientInstance.get().requestPasswordReset({
        requestPasswordResetDTO: { email: email!.trim() },
      });
      setState((prevState) => ({
        ...prevState,
        isSuccess: true,
      }));
    } catch (e) {
      ErrorInterceptor.error({ message: e.response.data.message });
    }
  };

  useEffect(() => {
    if (location.state?.email) {
      setState({ email: decodeEmail(location.state.email), isSuccess: false });
    }
  }, [location]);

  const isActive = validateEmail(email!);

  return (
    <div styleName="wrapper" data-testid="forgot-password">
      <div styleName="inside-wrapper">
        <div styleName="logo-pear" />
        {isSuccess ? (
          <div styleName="instruction">
            Password reset email is sent. Please check your email and follow the
            instructions.
          </div>
        ) : (
          <div>
            <div styleName="instruction">
              Enter your email address below.
              <br />
              We will send you an email to reset
              <br />
              your password.
            </div>
            <form onSubmit={handleSubmit} autoCorrect="off">
              <InputGeneral
                autoFocus
                label="Email Address"
                name="email"
                testidProp={'input-login-email'}
                value={email!}
                type="login"
                onChange={handleChangeEmail}
              />
              <div styleName="action-group">
                <ButtonMedium
                  buttonRole={'secondary'}
                  width={'145px'}
                  margin={'0px 5px 0px 0px'}
                  handleClick={handleCancel}
                >
                  Cancel
                </ButtonMedium>
                <ButtonMedium
                  testidProp={'submit-button'}
                  buttonRole={'primary'}
                  disabled={!isActive}
                  width={'145px'}
                  margin={'0px 0px 0px 5px'}
                  buttonType="submit"
                >
                  Send
                </ButtonMedium>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
